import { parse, serialize } from 'cookie';

export function getCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const all = parse(document.cookie || '');
  return all[name];
}

export function setCookie(
  name: string,
  value: string,
  maxAgeSeconds: number,
): void {
  if (typeof document === 'undefined') return;
  const cookieString = serialize(name, value, {
    path: '/',
    maxAge: maxAgeSeconds,
    sameSite: 'lax',
    secure:
      typeof window !== 'undefined' && window.location.protocol === 'https:',
  });
  document.cookie = cookieString;
}
